import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { constantsQuery } from '../constants/queries';

export const useConstantsQuery = () => {
  return useQuery({
    queryKey: ['constants'],
    queryFn: async () => {
      const response = await graphqlRequest(constantsQuery, {});
      return response?.constants;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export type ConstantsData = {
  categories: string[];
  genders: string[];
  languageCodes: string[];
  materials: string[];
  pathologies: string[];
  programSports: string[];
  sessionFlags: string[];
  specialPrograms: string[];
  userLevels: string[];
  weekFocus: string[];
  workoutFocus: string[];
  workoutSports: string[];
}; 